import { Link, Navigate, useParams } from 'react-router-dom';

import { Button, NotFoundPage, Page, Typography } from '@occc-app/design-system';
import { useChainId } from '@occc-app/Chain/hooks';

import { useGetStoredValueProgramByDiscountingOfferId } from './use-stored-value-program-by-discounting-offer.hook';

import { StoredValueUpdateLoading } from '../stored-value-update-page/stored-value-update-loading.component';
import { STORED_VALUE_UPDATE_PAGE_TITLE } from '../stored-value-update-page/stored-value-update-page.utils';
import { routeCreator } from '../stored-value.utils';

export const StoredValueUpdateByOfferPageContainer = () => {
  const chainId = useChainId();
  const { offerId = '' } = useParams<{ offerId: string }>();

  const {
    data: program,
    loading,
    error,
  } = useGetStoredValueProgramByDiscountingOfferId({
    offerId,
    chainId,
  });

  if (!offerId) {
    return <Navigate to={routeCreator.list} replace />;
  }

  if (loading) {
    return <StoredValueUpdateLoading />;
  }

  if (error) {
    return (
      <Page
        browserTabTitle={STORED_VALUE_UPDATE_PAGE_TITLE}
        pageHeaderProps={{ title: STORED_VALUE_UPDATE_PAGE_TITLE }}
        containerProps={{ variant: 'md' }}
      >
        <Typography paragraph>We could not load this stored value program.</Typography>
        <Button component={Link} to={routeCreator.list} variant='contained'>
          Back to Stored Values
        </Button>
      </Page>
    );
  }

  if (!program) {
    return <NotFoundPage />;
  }

  return <Navigate to={routeCreator.update(program.id)} replace />;
};
